import React from 'react';
import Link from '@material-ui/core/Link';

export const WrapWithLink = ({ link, children }: any) =>
  link ? <Link href={link}>{children}</Link> : children;
